import { Link } from '@mui/material';
import { useWorkspaceId } from 'api/providers/workspaceProvider';
import React from 'react';
import { FinsightEntity, FinsightEntityParent } from 'shared';

export type EntityTextViewProps = {
  /** Entity to display */
  entity: FinsightEntity | FinsightEntityParent;

  /** Search params to append to URL */
  searchParams: string;
};

export function EntityTextView(props: EntityTextViewProps) {
  const { entity, searchParams } = props;

  const workspaceId = useWorkspaceId();

  return (
    <Link
      key={entity.id}
      href={`/workspace/${workspaceId}/entity/${entity.id}?${searchParams}`}
    >
      {entity.name}
    </Link>
  );
}
